import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "m-bottomPanel__container body__no-scroll" }
const _hoisted_2 = { class: "m-bottomPanel__header" }
const _hoisted_3 = { class: "m-bottomPanel__headerText" }
const _hoisted_4 = { class: "m-bottomPanel__iconContainer" }
const _hoisted_5 = {
  "data-js": "panel-content",
  class: "m-bottomPanel__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "backdrop",
    onAfterLeave: _ctx.destroyPanel
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "m-bottomPanel__backdrop",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args)))
        }),
        _createElementVNode("div", {
          class: "m-bottomPanel__contentContainer",
          style: _normalizeStyle({ maxHeight: _ctx.maxHeight })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_IconComponent, {
                onClick: _ctx.closePanel,
                "icon-id": _ctx.IconName.Close
              }, null, 8, ["onClick", "icon-id"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 4)
      ], 512), [
        [_vShow, _ctx.panelVisible]
      ])
    ]),
    _: 3
  }, 8, ["onAfterLeave"]))
}